module.exports = __webpack_public_path__ + "img/DSSoft.8a02bffc.png";